import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 14V7h-2v8.054l5.039 3.371 1.051-1.502L15 14Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 14c0 6.075-4.925 11-11 11S3 20.075 3 14 7.925 3 14 3s11 4.925 11 11Zm-2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
);
export default IconWatchStrokedSizeL;
